import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExternalIntegrationService } from 'app/services/models/external-integration.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-external-integration-dialog',
  templateUrl: './external-integration-dialog.component.html',
  styleUrls: ['./external-integration-dialog.component.scss']
})
export class ExternalIntegrationDialogComponent implements OnInit {
  @Input() data: { id?: number; kindId: number };
  externalItegration: any = {};
  integrationForm: FormGroup;
  isEditMode = false;
  isMailIntegration = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private externalService: ExternalIntegrationService,
    private toastrService: ToastrService
  ) { }

  async ngOnInit() {
    this.isEditMode = !!this.data?.id;
    this.isMailIntegration = this.data.kindId === 3012; // Örnek mail entegrasyon kindId = 2

    this.integrationForm = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
      isActive: [true], // sadece edit modda gösterilecek
      smtpServer: [''],
      smtpPort: [null],
      useSSL: [false],
      senderEmail: ['', this.isMailIntegration ? [Validators.required, Validators.email] : []],
      senderName: [''],
    });

    if (this.isEditMode) {
      // Burada servisten data getirilebilir. Şimdilik sabit örnek:
      this.integrationForm.get('password')?.setValidators([]);
      await this.GetByIdExternalIntegration(this.data.id);
    }
  }

  async GetByIdExternalIntegration(id: number) {
    const data = await this.externalService.GetByIdExternalIntegration(id);
    console.log(data);
    this.externalItegration = data;
    this.integrationForm.patchValue({
      userName: data.userName,
      password: data.password,
      isActive: data.isActive,
      smtpServer: data.smtpServer,
      smtpPort: data.smtpPort,
      useSSL: data.useSSL,
      senderEmail: data.senderEmail,
      senderName: data.senderName,
    });
  }

  get f() {
    return this.integrationForm.controls;
  }

  async submit() {
    if (this.integrationForm.invalid) {
      this.integrationForm.markAllAsTouched();
      return;
    }

    const formValue = this.integrationForm.value;
    const payload = {
      ...formValue,
      kindId: this.data.kindId,
      id: this.data?.id
    };
    console.log(payload);
    if (this.isEditMode) {
      const response = await this.externalService.updateExternalIntergration(
        this.data.id,
        payload.userName,
        payload.password,
        this.data.kindId,
        payload.isActive == "true" ? true : false,
        payload.smtpServer,
        payload.smtpPort,
        payload.useSSL,
        payload.senderEmail,
        payload.senderName
      );
      if (response.status) {
        this.toastrService.success(response.message);
      } else {
        this.toastrService.error(response.message);
      }
    } else {
      const response = await this.externalService.createExternalIntegration(
        payload.userName,
        payload.password,
        this.data.kindId,
        payload.smtpServer,
        payload.smtpPort,
        payload.useSSL,
        payload.senderEmail,
        payload.senderName
      );
      if (response.status) {
        this.closeModal();
        this.toastrService.success(response.message);
      } else {
        this.toastrService.error(response.message);
      }
    }

    this.activeModal.close(true);

    this.activeModal.close(true);
  }

  closeModal() {
    this.activeModal.dismiss();
  }
}
